<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">​腾讯云xDeepSeek：率先上线最新版V3模型API接口、大模型知识引擎内置新模型服务</div>
      <div class="news-date">2025年3月26日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          3月25日晚，
          <span class="mark-text highlight">腾讯云率先上线DeepSeek-V3-0324版本</span>
          ，企业和开发者可以通过腾讯云直接调用新版模型的API接口，获得稳定优质的服务。同时，腾讯云旗下大模型知识引擎也接入了新版模型，通过平台内置的RAG和工作流能力，用户可以快速搭建专属AI应用。
        </p>
        <p>
          <span class="mark-text highlight">用户可以在腾讯云官网调用API接口：</span>
          <a href="https://cloud.tencent.com/document/product/1772/115963">https://cloud.tencent.com/document/product/1772/115963</a>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news72.webp"/>
          </div>
        </div>
        <p>
          <span class="mark-text highlight">也可以基于大模型知识引擎内置的V3新模型快速搭建应用：</span>
          <a href="https://cloud.tencent.com/product/lke">https://cloud.tencent.com/product/lke</a>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news72/news72_1.webp"/>
          </div>
        </div>
        <p>
          腾讯云DeepSeek-V3-0324 API接口的价格对标DeepSeek官方，
          <span class="mark-text highlight">输入为每百万tokens 2元，输出为每百万tokens 8元。</span>
        </p>
        <p>DeepSeek官方发布显示，新版V3模型借鉴 DeepSeek-R1 模型训练过程中所使用的强化学习技术，大幅提高了在推理类任务上的表现水平，在数学、代码类相关评测集上取得了超过GPT-4.5的得分成绩。</p>
        <p>在编程方面，前端开发能力增强，在 HTML 等代码前端任务上，新版V3模型生成的代码可用性更高，视觉效果也更加美观、富有设计感。多位开发者测评后认为，新版本的编程能力可以比肩Claud 3.5/3.7 Sonnet。</p>
        <p>在中文写作任务方面，新版V3模型基于R1的写作水平进行了进一步优化，同时特别提升了中长篇文本创作的内容质量。此外，新版V3模型可以在联网搜索场景下，对于报告生成类指令输出更为详实准确、排版更加清晰美观的结果。</p>
        <p>
          腾讯云是国内率先支持DeepSeek API+联网搜索的云厂商。2月初，腾讯云宣布上线DeepSeek-R1及V3原版模型API接口。同时，大模型知识引擎也接入了这两款模型，并率先支持联网搜索，帮助用户快速搭建联网应用。
          <span class="mark-text highlight">经过腾讯云的部署优化，大模型知识引擎吐字速率较使用开源推理引擎提升84%，成本降低46%。</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News72.vue